import React from 'react';
import { Alert as BootstrapAlert } from 'react-bootstrap';

const Alert = ({ type, message }) => {
  return (
    <BootstrapAlert variant={type || 'info'} className="mb-4">
      {message}
    </BootstrapAlert>
  );
};

export default Alert;